import * as React from 'react';

import { escape as escapeHtml } from 'lodash';

import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface Props extends Pick<DialogProps, 'onClose'> {
  open?: boolean;
  workspaceName: string;
  onConfirm: () => void;
}

export function JoinWorkspaceModal({
  open,
  onClose,
  onConfirm,
  workspaceName,
}: Props) {
  return (
    <div>
      <DialogConfirmation
        id="invalid-quiz"
        open={open}
        title={translate('Join Shared Library')}
        onClose={onClose}
        closeLabel={translate('Close')}
        actions={[
          <UIButton onClick={onClose} key="cancel">
            {translate('Cancel')}
          </UIButton>,
          <UIButton key="primary" appearance="primary" onClick={onConfirm}>
            {translate('Join Library')}
          </UIButton>,
        ]}
        data-testid="invalid-modal"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: translate(
              'Start collaborating with members on <strong>{0}</strong>.'
            ).format(escapeHtml(workspaceName)),
          }}
        ></div>
      </DialogConfirmation>
    </div>
  );
}
